

  export default {
    name: 'PageBackgroundCircle',

    props: {
        data: {
            type: Array,
            default: () => [],
          },
        radius: {
          type: Number,
          default: 315,

        }
    },

    data() {
      return {
      }
    },
  }
